import React from 'react'
import {
  getMonthAndDay,
  getWeekCount,
  getDayOfWeek
} from '../../utils/dateUtils'

const ZeroAcceptReject = ({ userReport, dateStart, dateEnd }) => {
  const isSameWeek = getWeekCount(dateStart, dateEnd) <= 1
  return (
    <div>
      <h3> 0 Accept, 0 Reject </h3>
      {userReport.map(user => (
        user.zeroAcceptReject.length
          ? (
            <li key={user.name}>
              {user.name}: {user.zeroAcceptReject.length}: {
                user.zeroAcceptReject
                  .map(ans => isSameWeek
                    ? `${getDayOfWeek(ans[0].created || ans[0].report_date)}`
                    : `${getMonthAndDay(ans[0].created || ans[0].report_date)}`
                  )
                  .join(', ')
              }
            </li>
            )
          : ''
      ))}
    </div>
  )
}

export default ZeroAcceptReject
